/**
 * v1 drops the copy of the delivery config and everything derived from it.
 *
 * Without a migration a returning guest keeps a blob shaped like the old slice
 * -- `currentDeliveryConfig`, `deliveryFees`, the estimated times, the zone id
 * -- and none of it maps onto the new shape, so autoMergeLevel1 would splice
 * those dead keys back into the store and leave `currentDeliveryConfigId` null.
 * That silently drops the guest's delivery selection on their next visit.
 *
 * So the id is carried across and the rest is dropped, which also clears the
 * stale values out of localStorage rather than leaving them to sit there
 * forever. prepits/project#4204
 */
// Returns a promise because that is redux-persist's migrate contract; the work
// itself is synchronous.
export const migrateDelivery = (
  state:
    | (Record<string, unknown> & { currentDeliveryConfig?: { id?: number } })
    | undefined
) => {
  if (!state) {
    return Promise.resolve(state);
  }

  const {
    currentDeliveryConfig,
    deliveryType: _deliveryType,
    deliveryFees: _deliveryFees,
    minEstimatedTime: _minEstimatedTime,
    maxEstimatedTime: _maxEstimatedTime,
    deliveryZoneId: _deliveryZoneId,
    ...keep
  } = state;

  return Promise.resolve({
    ...keep,
    // What is ALREADY stored wins. redux-persist runs `migrate` on every
    // rehydration, not only when the version moves -- that comparison is what
    // `createMigrate` adds, and this is hand-written. So once the state is v1
    // there is no `currentDeliveryConfig` key left, and reading the id off it
    // unconditionally overwrote a perfectly good `currentDeliveryConfigId`
    // with null on EVERY page load. The guest kept their delivery selection
    // inside a session and lost it on any full navigation.
    currentDeliveryConfigId:
      keep.currentDeliveryConfigId ?? currentDeliveryConfig?.id ?? null,
  });
};
